import {
    PSMS_TAXID_EXTENDED_TIN_FAILURE,
    PSMS_TAXID_EXTENDED_TIN_LOADING,
    PSMS_TAXID_EXTENDED_TIN_SUCCESS,
    PSMS_TAXID_HEALTH_SYSTEM_FAILURE,
    PSMS_TAXID_HEALTH_SYSTEM_LOADING,
    PSMS_TAXID_HEALTH_SYSTEM_SUCCESS,
} from '@src/middleware/actions/actionTypes';

export interface PsmsViewTaxIdState {
    healthSystemData: any | null;
    healthSystemDataLoading: boolean;
    healthSystemDataError: any;
    extendedTinList: any | null;
    extendedTinListLoading: boolean;
    extendedTinListError: any;
}

const initialState: PsmsViewTaxIdState = {
    healthSystemData: null,
    healthSystemDataLoading: true,
    healthSystemDataError: null,
    extendedTinList: null,
    extendedTinListLoading: true,
    extendedTinListError: null,
};

export default function psmsViewTaxIdReducer(
    state: PsmsViewTaxIdState = initialState,
    action: { type: string; payload?: any }
): PsmsViewTaxIdState {
    switch (action.type) {
        case PSMS_TAXID_HEALTH_SYSTEM_LOADING:
            return { ...state, healthSystemDataLoading: action.payload };
        case PSMS_TAXID_HEALTH_SYSTEM_SUCCESS:
            return { ...state, healthSystemData: action.payload, healthSystemDataError: null };
        case PSMS_TAXID_HEALTH_SYSTEM_FAILURE:
            return { ...state, healthSystemDataError: action.payload, healthSystemDataLoading: false };
        case PSMS_TAXID_EXTENDED_TIN_LOADING:
            return { ...state, extendedTinListLoading: action.payload };
        case PSMS_TAXID_EXTENDED_TIN_SUCCESS:
            return { ...state, extendedTinList: action.payload, extendedTinListError: null };
        case PSMS_TAXID_EXTENDED_TIN_FAILURE:
            return { ...state, extendedTinListError: action.payload, extendedTinListLoading: false };
        default:
            return state;
    }
}
